module.exports = __webpack_public_path__ + "static/media/3_5.236d5f01.jpg";